module.exports = __webpack_public_path__ + "img/medication_optimization_safety.b9970f2a.svg";